import { render } from "./ProfileChangePasswordComponent.vue?vue&type=template&id=270e7f3a"
import script from "./ProfileChangePasswordComponent.vue?vue&type=script&lang=js"
export * from "./ProfileChangePasswordComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/profile/ProfileChangePasswordComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "270e7f3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('270e7f3a', __exports__)) {
    api.reload('270e7f3a', __exports__)
  }
  
  module.hot.accept("./ProfileChangePasswordComponent.vue?vue&type=template&id=270e7f3a", () => {
    api.rerender('270e7f3a', render)
  })

}


export default __exports__